import script from "./landInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./landInfo.vue?vue&type=script&setup=true&lang=js"

import "./landInfo.vue?vue&type=style&index=0&id=1ed4618c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ed4618c"]])

export default __exports__